<template>
  <div id="forkids" style="background-image: url(/static/images/5183000.jpg) !important">
    <el-drawer :destroy-on-close="true" :append-to-body="true" title="Ayarlar" :visible.sync="settings"
      :with-header="false" class="aaaa">
      <div class="row p-5">
        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Okuma Sesi</label>
          <el-select :popper-append-to-body="false" placeholder="Ses Cinsiyeti Seçin" v-model="gender"
            :disabled="text == null || text == ''">
            <el-option v-for="item in ['male', 'female']" :label="item == 'male' ? 'Erkek' : 'Kadın'" :key="item"
              :value="item"></el-option>
          </el-select>
        </div>
        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Okuma Metni</label>
          <el-select :popper-append-to-body="false" placeholder="Hazır Metin Seçebilirsiniz" v-model="templateText">
            <el-option v-for="item in templates" :label="item.title" :key="item.id" :value="item.id"></el-option>
          </el-select>
        </div>

        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Okuma</label>
          <el-switch v-model="soundActive" active-text="Açık" :inactive-text="'Kapalı'"
            :disabled="text == null || text == ''"></el-switch>
        </div>

        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Hız
            <span v-if="content.blocks.length">{{
              parseInt(
              (content.blocks.reduce(
              (counter, item) => (counter += item.length),
              0
              ) /
              (totalDuration * 1.05)) *
              60
              )
              }}
              Kelime/Dakika</span></label>
          <el-slider style="display: flex; flex: 1" v-model="speed" :min="0.5" :max="1.7" :step="0.1"
            :disabled="text == null || text == ''"></el-slider>
        </div>

        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Yazı Boyutu</label>
          <el-slider style="display: flex; flex: 1" v-model="fontSize" :min="12" :max="maxFontSize" :step="1"
            :disabled="text == null || text == ''"></el-slider>
        </div>

        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Dış Çizgi Vurgusu</label>
          <el-slider style="display: flex; flex: 1" v-model="config.borderOpacity" :min="0" :max="100" :step="5"
            :disabled="text == null || text == ''"></el-slider>
        </div>
        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Arka Renk Vurgusu</label>
          <el-slider style="display: flex; flex: 1" v-model="config.backgroundOpacity" :min="0" :max="100"
            :step="5"></el-slider>
        </div>
        <div class="col-md-12 mt-4">
          <label for="">Satır Modu</label>
          <el-radio-group v-model="config.rowMode">
            <el-radio v-for="item in ['Normal', 'Silinerek', 'Açılarak']" :label="item" :key="item"
              :value="item"></el-radio>
          </el-radio-group>
        </div>
        <div class="col-md-12 mt-4">
          <label for="">Sütun Modu</label>
          <el-radio-group v-model="config.colMode">
            <el-radio v-for="item in ['Normal', 'Silinerek', 'Açılarak']" :label="item" :key="item"
              :value="item"></el-radio>
          </el-radio-group>
        </div>
        <div class="col-md-12 mt-4">
          <label for="">Renklendirme</label>
          <el-radio-group v-model="colorMode">
            <el-radio v-for="item in [
                'Yok',
                'Kelimeler Renkli',
                'İlk Hece Renkli',
                'Son Hece Renkli',
                'İlk ve Son Hece Renkli',
              ]" :label="item" :key="item" :value="item"></el-radio>
          </el-radio-group>
        </div>

        <div class="col-md-12 mt-4">
          <label for="">Hece Modu</label>
          <el-radio-group v-model="heceModu">
            <el-radio v-for="item in [
                'Yok',
                'İlk Hece Noktalı',
                'İlk Hece Altı Çizili',
                'Son Hece Noktalı',
                'Son Hece Altı Çizili',
              ]" :label="item" :key="item" :value="item"></el-radio>
          </el-radio-group>
        </div>
        <div class="col-md-12 mt-4">
          <label for="">Hece Vurgu Rengi</label>
          <el-color-picker color-format="rgb" show-alpha v-model="heceRengi"></el-color-picker>
        </div>
      </div>
    </el-drawer>
    <div id="stage" v-loading="loading" @click="
        pause = true;
        $root.$emit('pause', true);
      ">
      <paused v-if="pause" @click="
          $root.$emit('pause', !pause);
          pause = false;
        "></paused>
      <div class="
          col-md-12
          mt-4
          d-flex
          flex-column
          align-items-center
          justify-content-center
        " v-if="content.text == ''">
        <label for="" style="font-size: 22px; margin-bottom: 20px; color: black">Başlamak İçin Metin Seçin</label>
        <el-select :popper-append-to-body="false" placeholder="Hazır Metin Seçebilirsiniz" v-model="templateText">
          <el-option v-for="(item, index) in templates" :label="item.title" :key="index" :value="item.id"></el-option>
        </el-select>
      </div>
      <a href="javascript:;" @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        " class="pause">
        <i :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"></i>
      </a>
      <a href="javascript:;" @click.stop="settings = true" class="settings">
        <i class="el-icon-setting"></i>
      </a>
      <h1 v-if="content.blocks.length" style="
          position: absolute;
          top: -30px;
          left: 0px;
          font-size: 20px;
          font-weight: bold;
          color: white;
          text-shadow: 0px 0px 3px rgb(0 0 0 / 30%);
        ">
        {{
        parseInt(
        (content.blocks.reduce(
        (counter, item) => (counter += item.length),
        0
        ) /
        (totalDuration * 1.05)) *
        60
        )
        }}
        Kelime/Dakika
      </h1>
      <div style="
          height: 100%;
          width: 100%;
          overflow: hidden;
          overflow-y: auto;
          padding: 4px;
        " id="scroll">
        <h3 v-if="content.text" class="text-center mt-5 mb-5" style="font-size: 32px">
          {{ templates.find((k) => k.text == content.text).title }}
        </h3>
        <div :style="getRowStyle(rowIndex)" v-for="(block, rowIndex) in content.blocks" :id="'row-' + rowIndex"
          class="d-flex flex-row align-items-center justify-content-center">
          <div v-for="(item, index) in block" class="pl-1 pr-1" :class="
              index == currentCol && rowIndex == currentRow
                ? 'active-block'
                : ''
            " :style="{
              fontSize: fontSize + 'px',
              ...getColStyle(index, rowIndex),
              border:
                index == currentCol && rowIndex == currentRow
                  ? '1px solid rgba(0,0,0,' + config.borderOpacity / 100 + ')'
                  : '1px solid transparent',
              backgroundColor:
                index == currentCol && rowIndex == currentRow
                  ? 'rgba(255,255,255,' + config.backgroundOpacity / 100 + ')'
                  : '',
            }" style="position: relative">
            {{ item.text }}
            <span v-if="colorMode.indexOf('İlk') != -1" style="
                color: transparent;
                position: absolute;
                left: 0.25rem;
                bottom: 0px;
              " :style="{ color: heceRengi }">{{ item.heceler[0] }}</span>
            <span v-if="colorMode.indexOf('Son') != -1" style="
                color: transparent;
                position: absolute;
                right: 0.25rem;
                bottom: 0px;
              " :style="{ color: heceRengi }">{{ item.heceler[item.heceler.length - 1] }}</span>
            <span v-if="heceModu == 'İlk Hece Altı Çizili'" style="
                color: transparent;
                position: absolute;
                left: 0.25rem;
                bottom: 0px;
                height: 0px;
              " :style="{ borderBottom: '1px solid ' + heceRengi }">{{ item.heceler[0] }}</span>

            <span v-if="heceModu == 'İlk Hece Noktalı'" style="
                color: transparent;
                position: absolute;
                left: 0.25rem;
                bottom: 0px;
                height: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
              ">{{ item.heceler[0]
              }}<span style="
                  width: 5px;
                  height: 5px;
                  border-radius: 50%;
                  position: absolute;
                " :style="{ backgroundColor: heceRengi }"></span></span>

            <span v-if="heceModu == 'Son Hece Altı Çizili'" style="
                color: transparent;
                position: absolute;
                right: 0.25rem;
                bottom: 0px;
                height: 0px;
              " :style="{ borderBottom: '3px dotted ' + heceRengi }">{{ item.heceler[item.heceler.length - 1] }}</span>

            <span v-if="heceModu == 'Son Hece Noktalı'" style="
                color: transparent;
                position: absolute;
                right: 0.25rem;
                bottom: 0px;
                height: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
              ">{{ item.heceler[item.heceler.length - 1]
              }}<span style="
                  width: 5px;
                  height: 5px;
                  border-radius: 50%;
                  position: absolute;
                " :style="{ backgroundColor: heceRengi }"></span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";

export default {
  name: "ForKids",
  data() {
    return {
      content: {
        text: "",
        type: "reverse",
        blocks: [],
        colors: ["purple", "red", "blue", "pink", "green", "orange"],
        totalRow: 0,
        totalCol: 0,
      },
      fontSize: 20,
      currentRow: 0,
      currentCol: 0,
      sounds: [],
      text: null,
      templates: [],
      templateText: null,
      speed: 1,
      loading: false,
      gender: "male",
      sound: null,
      soundActive: true,
      config: {
        colMode: "Normal",
        rowMode: "Normal",
        borderOpacity: 100,
        backgroundOpacity: 100,
      },
      pause: false,
      settings: false,
      markIndex: 0,
      colorful: true,
      repeat: true,
      newLines: [],
      soundLock: false,
      heceModu: "yok",
      heceRengi: "red",
      colorMode: "Kelimeler Renkli",
      maxFontSize: 40,
      totalDuration: 0,
    };
  },
  async created() {
    this.loading = true;
    axios
      .post("module/kid_contents", { module: "ileri-seviye-siir" })
      .then((res) => {
        this.templates = res.data.data.map((k) => {
          return {
            text: k.text,
            id: k.slug,
            title: k.title,
          };
        });
        this.loading = false;
      });
  },
  methods: {
    checkInView(ele, container) {
      if (container.scrollTop + 600 - ele.offsetTop < 150) {
        return true;
      }
      return false;
    },
    getRowStyle(index) {
      var opacity = 1;
      if (this.config.rowMode == "normal") {
        opacity = 1;
      }
      if (this.config.rowMode == "Silinerek" && index < this.currentRow) {
        opacity = 0;
      }

      if (this.config.rowMode == "Açılarak" && index > this.currentRow) {
        opacity = 0;
      }
      if (this.config.rowMode == "Açılarak" && index <= this.currentRow) {
        opacity = 1;
      }
      var marginBottom = 0;
      if (this.newLines.some((x) => x == index)) {
        marginBottom = 20;
      }
      return { opacity, marginBottom: marginBottom + "px" };
    },
    getColStyle(index, rowIndex) {
      var opacity = 1;
      if (this.config.colMode == "normal") {
        opacity = 1;
      }
      if (
        (this.config.colMode == "Silinerek" &&
          index < this.currentCol &&
          rowIndex == this.currentRow) ||
        (this.currentRow > rowIndex && this.config.colMode == "Silinerek")
      ) {
        opacity = 0;
      }

      if (
        (this.config.colMode == "Açılarak" &&
          index > this.currentCol &&
          rowIndex == this.currentRow) ||
        (this.currentRow < rowIndex && this.config.colMode == "Açılarak")
      ) {
        opacity = 0;
      }

      return { opacity };
    },
    getTextSize(text, font) {
      const canvas =
        this.getTextSize.canvas ||
        (this.getTextSize.canvas = document.createElement("canvas"));
      const context = canvas.getContext("2d");
      context.font = font;
      const metrics = context.measureText(text);
      return {
        width: metrics.width,
        height:
          metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent,
      };
    },

    getCssStyle(element, prop) {
      return window.getComputedStyle(element, null).getPropertyValue(prop);
    },

    getCanvasFontSize(el = document.body) {
      const fontWeight = getCssStyle(el, "font-weight") || "normal";
      const fontSize = getCssStyle(el, "font-size") || "16px";
      const fontFamily = getCssStyle(el, "font-family") || "Times New Roman";

      return `${fontWeight} ${fontSize} ${fontFamily}`;
    },
    start() {
      if (this.soundActive == true) {
        this.sound.sound.volume = 1;
      } else {
        this.sound.sound.volume = 0;
      }
      this.sound.sound.onplay = () => {
        if (this.soundLock) {
          this.soundLock = false;
          return;
        }
        this.markIndex = 0;

        this.sound.interval = setInterval(() => {
          if (this.pause) return;
          let a = this.sound.timePoints
            .filter(
              (k) => k.timeSeconds * 1000 <= this.sound.sound.currentTime * 1000
            )
            .reverse()[0];

          if (a != undefined && a != null) {
            this.markIndex = parseInt(a.markName);
          } else {
            this.markIndex = 0;
          }

          this.currentRow = this.content.blocks.findIndex((k) =>
            k.some((x) => x.wordIndex == this.markIndex)
          );

          this.currentCol = this.content.blocks[this.currentRow].findIndex(
            (k) => k.wordIndex == this.markIndex
          );
        });
      };

      this.sound.sound.onended = () => {
        clearInterval(this.sound.interval);
        if (this.repeat == true) {
          this.sound.sound.play();
          $("#scroll").animate({ scrollTop: 0 }, 500, "swing");
        }
      };

      this.sound.sound.play();
    },
    sesli(harf) {
      var sesliharfler = "aîûaeıioöuüAÎÛAEIİOÖUÜ";

      if (sesliharfler.indexOf(harf) > -1) {
        return true;
      } else {
        return false;
      }
    },
    hecele(s) {
      var ss = "";
      var hece = "";
      var boşluk = " ";
      var renkler = ["red", "blue"];
      var x = renkler.length;
      var sayaç = 0;

      var heceler = [];

      for (var i = s.length - 1; i >= 0; i--) {
        hece = s[i] + hece;
        if (
          s[i] == "'" &&
          i > 0 &&
          this.sesli(s[i - 1]) == true &&
          hece.length > 2
        ) {
          ss =
            "<span style='color:" +
            renkler[sayaç % x] +
            "'>" +
            hece +
            "</span>" +
            ss;
          heceler.push(hece);
          hece = "";
          sayaç++;
        } else if (
          s[i] == "'" &&
          i > 1 &&
          this.sesli(s[i - 1]) == false &&
          this.sesli(s[i + 1]) == true
        ) {
          ss =
            "<span style='color:" +
            renkler[sayaç % x] +
            "'>" +
            s[i - 1] +
            hece +
            "</span>" +
            ss;
          heceler.push(hece);
          hece = "";
          sayaç++;
          i--;
        } else {
          if (i == 0) {
            ss =
              "<span style='color:" +
              renkler[sayaç % x] +
              "'>" +
              hece +
              "</span>" +
              ss;
            heceler.push(hece);
            hece = "";
            sayaç++;
          } else {
            if (hece.length == 1) {
              if (
                i > 0 &&
                this.sesli(s[i]) == true &&
                this.sesli(s[i - 1]) == true
              ) {
                ss =
                  "<span style='color:" +
                  renkler[sayaç % x] +
                  "'>" +
                  hece +
                  "</span>" +
                  ss;
                heceler.push(hece);
                hece = "";
                sayaç++;
              }
            }

            if (hece.length == 2) {
              if (
                hece[0] == "r" &&
                s[i - 1] == "t" &&
                this.sesli(s[i - 2]) == false
              ) {
              } else {
                if (i > 1 && s[i - 1] != "'") {
                  if (
                    this.sesli(s[i]) == false &&
                    this.sesli(s[i + 1]) == true
                  ) {
                    ss =
                      "<span style='color:" +
                      renkler[sayaç % x] +
                      "'>" +
                      hece +
                      "</span>" +
                      ss;
                    heceler.push(hece);
                    hece = "";
                    sayaç++;
                  }
                  if (
                    this.sesli(s[i]) == true &&
                    this.sesli(s[i - 1]) == true
                  ) {
                    ss =
                      "<span style='color:" +
                      renkler[sayaç % x] +
                      "'>" +
                      hece +
                      "</span>" +
                      ss;
                    heceler.push(hece);
                    hece = "";
                    sayaç++;
                  }
                } else if (
                  this.sesli(s[i]) == false &&
                  this.sesli(s[i - 1]) == true &&
                  this.sesli(s[i + 1]) == true
                ) {
                  ss =
                    "<span style='color:" +
                    renkler[sayaç % x] +
                    "'>" +
                    hece +
                    "</span>" +
                    ss;
                  heceler.push(hece);
                  hece = "";
                  sayaç++;
                }
              }
            }

            if (hece.length == 3) {
              if (i > 1) {
                if (
                  hece[0] == "r" &&
                  s[i - 1] == "t" &&
                  this.sesli(s[i - 2]) == false
                ) {
                } else {
                  if (this.sesli(s[i]) == false && s[i - 1] != "'") {
                    ss =
                      "<span style='color:" +
                      renkler[sayaç % x] +
                      "'>" +
                      hece +
                      "</span>" +
                      ss;
                    heceler.push(hece);
                    hece = "";
                    sayaç++;
                  }
                }
              } else if (
                this.sesli(s[i]) == false &&
                this.sesli(s[i - 1]) == true
              ) {
                ss =
                  "<span style='color:" +
                  renkler[sayaç % x] +
                  "'>" +
                  hece +
                  "</span>" +
                  ss;
                heceler.push(hece);
                hece = "";
                sayaç++;
              }
            }

            if (hece.length == 4) {
              ss =
                "<span style='color:" +
                renkler[sayaç % x] +
                "'>" +
                hece +
                "</span>" +
                ss;
              heceler.push(hece);
              hece = "";
              sayaç++;
            }
          }
        }
      }

      return heceler.reverse();
    },
    async init() {
      if (this.sound && this.sound.sound) {
        this.sound.sound.onplay = null;
        this.sound.sound.onended = null;
        this.sound.sound.pause();
      }

      this.loading = true;
      var rowIndex = 1;

      this.currentRow = 0;
      this.currentCol = 0;

      clearInterval(this.interval);
      this.interval = null;

      this.sounds = [];

      this.content.blocks = [];
      this.newLines = [];

      var colIndex = 0;
      var index2 = 0;
      var y = [];
      this.content.text.split(" ").map((k, index) => {
        if (k == "<n>") {
          this.content.blocks.push(y);
          y = [];
          index2 = 0;
        } else if (k == "<nl>") {
          this.newLines.push(this.content.blocks.length - 1);
        } else {
          y.push({
            text: k,
            color: "red",
            index: index2,
            wordIndex: colIndex,
            heceler: this.$hecele(k),
          });
          index2 += 1;
          colIndex += 1;

          if (index == this.content.text.split(" ").length - 1) {
            this.content.blocks.push(y);
          }
        }
      });

      this.longestWord = this.content.blocks
        .map((k) => k.map((x) => x.text).join(" "))
        .sort(function (a, b) {
          return b.length - a.length;
        })[0];

      var fSize = 2;

      while (true) {
        if (
          this.getTextSize(this.longestWord, "normal " + fSize + "px Arial")
            .width > 700
        ) {
          this.maxFontSize = fSize;
          break;
        } else {
          fSize += 1;
        }
      }

      await axios
        .post("module/ttsWordWithSpeed", {
          text: this.content.text
            .split(" ")
            .filter((k) => k != "<n>" && k != "<nl>")
            .join(" "),
          gender: this.gender,
          speed: this.speed,
          id:
            this.templates.find((x) => x.text == this.content.text).id +
            "_" +
            "0" +
            "_" +
            this.speed,
        })
        .then((res) => {
          var audio = new Audio("data:audio/mp3;base64," + res.data.sound);

          audio.onloadedmetadata = () => {
            this.totalDuration = audio.duration;
          };

          this.sound = {
            sound: audio,
            timePoints: res.data.timepoints,
          };
        });

      clearTimeout(this.timeout);
      this.timeout = null;
      this.timeout = setTimeout(() => {
        this.start();
        this.loading = false;
      }, 750);
    },
  },
  watch: {
    currentRow: function () {
      if (
        this.checkInView(
          document.getElementById("row-" + this.currentRow),
          document.getElementById("scroll")
        ) === true
      ) {
        $("#scroll").animate(
          { scrollTop: $("#scroll").scrollTop() + 150 },
          500,
          "swing"
        );
      }
    },
    templateText: function () {
      if (this.templateText == null) return;
      this.content.text = this.templates.find(
        (k) => k.id == this.templateText
      ).text;
      this.text = this.content.text = this.templates.find(
        (k) => k.id == this.templateText
      ).text;
      this.templateText = null;
    },
    speed: function () {
      if (this.content.text == null || this.content.text == "") return;
      clearTimeout(this.x);
      this.x = setTimeout(() => {
        this.init();
      }, 700);
    },
    text: function () {
      clearTimeout(this.x);
      this.content.text = this.text;
      this.x = setTimeout(() => {
        this.init();
      }, 1200);
    },
    gender: function () {
      clearTimeout(this.x);
      this.x = setTimeout(() => {
        this.init();
      }, 700);
    },
    repeat: function () {
      if (
        this.repeat == true &&
        this.sound != null &&
        this.sound.sound.paused == true
      ) {
        this.sound.sound.play();
      }
    },
    soundActive: function () {
      if (this.sound != null) {
        this.sound.sound.volume = this.soundActive == true ? 1 : 0;
      }
    },
    pause: function () {
      if (this.pause == true && this.sound.sound) {
        this.sound.sound.pause();
      }

      if (this.pause == false && this.sound.sound) {
        this.soundLock = true;
        this.sound.sound.play();
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearTimeout(this.timeout);
    if (this.sound && this.sound.sound) {
      this.sound.sound.onplay = null;
      this.sound.sound.onended = null;
      this.sound.sound.pause();
    }
    this.timeout = null;
    this.interval = null;
  },
};
</script>

<style lang="less" scoped>
#forkids {
  background-image: url("/static/images/5183000.jpg");
  width: 100%;
  height: calc(100vh - 53px);
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  #stage {
    width: 800px;
    height: 800px;
    background-color: #dcfbff;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;

    .active-block {
      background: white;
      border-radius: 15px;
    }
  }
}

.el-select-dropdown {
  z-index: 9999999 !important;
}

.aaaa {
  label {
    display: block;
  }

  .el-select {
    width: 100%;
  }

  .el-radio-group {
    font-size: 0;
    width: 100%;
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
    flex-direction: column;
  }
}
</style>

<style>
.el-color-picker__panel {
  z-index: 999999999999 !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/SiirWord.vue